import { render, staticRenderFns } from "./TenantCourse.vue?vue&type=template&id=34b6f44e&"
import script from "./TenantCourse.vue?vue&type=script&lang=js&"
export * from "./TenantCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports